import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/master/aboutus/Slice";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { Controller, useForm } from "react-hook-form";
import JoditEditor from "jodit-react";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
import { Offcanvas } from "react-bootstrap";

function Edit({ show, onHide, id, setId, setShowError, setSuccess, setErr }) {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
    trigger,
    image_required = true,
  } = useForm();
  const imageFile = watch("image");
  const descriptionValue = watch("description");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        reset(res?.payload?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("description", data?.description);
      // sendData.append("image", data?.image[0]);
      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        await setId("");
        setSuccess(true);
        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
          onHide();
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Namee", error);
    }
  };
  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Edit About Us</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="forms_section">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-12 mb-3">
                <div className="form-group">
                  <Form.Label>Name</Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="Name"
                    {...register("name", {
                      required: "Name is Required",
                      maxLength: {
                        value: 100,
                        message: "Name cannot exceed 100 characters",
                      },
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.name,
                    })}
                  />

                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </div>

                {/* <Form.Group
                  className="form-field mb-3"
                  controlId="formBasicEmail"
                >
                  <Form.Label>Image</Form.Label>
                  <Form.Control
                    className={classNames("", {
                      "is-invalid": errors?.image,
                    })}
                    type="file"
                    {...register("image", {
                      // required: image_required
                      //   ? "Image is required"
                      //   : image_required,
                      required:
                        typeof getValues("image") == "string"
                          ? false
                          : " Image is required",
                      validate: async (value) => {
                        // if (typeof value !== "string") {
                        //   const fileTypes = ["jpg", "png", "jpeg"];
                        //   const fileType = value[0].name?.split(".")[1];
                        //   if (!fileTypes.includes(fileType)) {
                        //     return `please upload a valid file format. (${fileTypes})`;
                        //   }
                        // }
                      },
                    })}
                    //   {...register("image", {
                    //     validate: (value) => {
                    //       const currentImage = getValues("image");

                    //       if (
                    //         image_required &&
                    //         typeof currentImage !== "string" &&
                    //         (!value || value.length === 0)
                    //       ) {
                    //         return "Image is required";
                    //       }

                    //       return true;
                    //     },
                    //   })}
                    accept=".jpg, .jpeg, .png"
                  />
                  {errors.image && (
                    <span className="text-danger">{errors.image.message}</span>
                  )}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="text-center">Image Preview</Form.Label>
                  {typeof getValues("image") == "string" ? (
                    <div className="image-preview-container">
                      <img
                        src={IDS.IMG_URL + getValues("image")}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "150px", height: "130px" }}
                      />
                    </div>
                  ) : (
                    imageFile &&
                    imageFile?.length > 0 && (
                      <div className="image-preview-container">
                        <img
                          // src={URL.createObjectURL(getValues("image")[0])}
                          src={URL?.createObjectURL(imageFile[0])}
                          alt="Preview"
                          className="image-preview"
                          style={{ width: "100px", height: "100px" }}
                        />
                      </div>
                    )
                  )}
                </Form.Group> */}

                <div className="row">
                  <div className="col-lg-12 col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label>Description</Form.Label>
                      <Controller
                        name="description" // Provide the field name
                        control={control} // Pass the control object from useForm()
                        rules={{
                          required: "description is required",
                        }} // Validation rules
                        render={({ field }) => (
                          <JoditEditor
                            value={descriptionValue || ""}
                            onBlur={(newContent) => {
                              setValue("description", newContent);
                              trigger("description");
                            }}
                          />
                        )}
                      />
                      {errors.description && (
                        <span className="text-danger">
                          {errors.description.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="form_submit_div ">
              <div className="row">
                <div className="col-lg-4 mx-auto mb-3">
                  <div className="button_group">
                    <button
                      type="button"
                      className="closebtn theme_bg"
                      onClick={() => {
                        onHide();
                        setId();
                      }}
                    >
                      Back
                    </button>
                    <button
                      type="button"
                      className="addbtn"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
        <Successfull_Modal
          message={"Successful"}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Edit;
